module.exports = __webpack_public_path__ + "img/example.3f4dbe9f.png";